var CARS = [
['AA05C9B3','ABARTH','GRANDE PUNTO','199','2007 > 2018'],
['AA8409DE11','AIWAYS','U5','MAS861','2021 >'],
['22FFCBED91','ALFA ROMEO','159','939','09/2005 > 11/2011'],
['AA4E1D2B','ALFA ROMEO','BRERA','939','2005 > 2010'],
['AE099F2B','ALFA ROMEO','GIULIETTA NOT BREMBO BRAKES','940','04/2010 >'],
['A6C0BD2B','ALFA ROMEO','MiTo','955','2008 > 2018'],
['A0DF4F2B','ALFA ROMEO','STELVIO','949','2017 >'],
['A2E9CF2B','ALFA ROMEO','TONALE','AV1','2022 >'],
['AA8770A21','AUDI','A1','8X','09/2010 > 2018'],
['A25A78A21','AUDI','A1 CITYCARVER','GB','2020 >'],
['A4FF80A21','AUDI','A1 SPORTBACK','8X','2012 > 2018'],
['45FF80A21','AUDI','A1 SPORTBACK','GB','2019 >'],
['AE58A0A21','AUDI','A2','8Z','1999 > 2005'],
['A8C0C0A21','AUDI','A3','8V','09/2012 > 2019'],
['E9C0C0A21','AUDI','A3','8P','2003 > 08/2012'],
['8AC0C0A21','AUDI','A3','GY','2020 >'],
['49C0C0A21','AUDI','A3','8L','1996 > 2003'],
['A239D0A21','AUDI','A3 CABRIOLET','8V','09/2012 > 2019'],
['4339D0A21','AUDI','A3 CABRIOLET','8P','2008 > 08/2012'],
['E70A01A21','AUDI','A3 SPORTBACK','GY','2020 >'],
['A60A01A21','AUDI','A3 SPORTBACK','8V','09/2012 > 2019'],
['470A01A21','AUDI','A3 SPORTBACK','8P','2004 > 08/2012'],
['A44351A21','AUDI','A4','B8 (8K)','11/2007 > 10/2015'],
['454351A21','AUDI','A4','B8 (F4)','11/2015 >'],
['864351A21','AUDI','A4','8E','2001 > 2007'],
['AEAB61A21','AUDI','A4 Allroad','B8 (8K)','06/2009 > 10/2015'],
['4FAB61A21','AUDI','A4 Allroad','B8 (F4)','2016 >'],
['438C91A21','AUDI','A4 AVANT','8E','2001 > 2007'],
['E38C91A21','AUDI','A4 AVANT','B8 (8K)','11/2007 > 10/2015'],
['A28C91A21','AUDI','A4 AVANT','B8 (F4)','11/2015 >'],
['ACE4B1A21','AUDI','A4 CABRIOLET','8H','2002 > 2009'],
['A0C5E1A21','AUDI','A5','B8 (8T)','06/2007 > 09/2016'],
['AA2EF1A21','AUDI','A5 CABRIOLET','B8 (8F)','2009 > 09/2016'],
['AE2687A21','AUDI','A5 COUPE - A5 SPORTBACK','B8 (F5)','10/2016 >'],
['496742A21','AUDI','A6','4B','1997 > 2004'],
['E96742A21','AUDI','A6','4F','2004 > 12/2010'],
['8A6742A21','AUDI','A6','F2','2018 >'],
['A86742A21','AUDI','A6','4G-4G1','2011 > 2017'],
['84DF52A21','AUDI','A6 ALLROAD','F2','2019 >'],
['A2DF52A21','AUDI','A6 ALLROAD','4F','06/2006 > 2011'],
['E3DF52A21','AUDI','A6 ALLROAD','4G-4G1','2012 > 2018'],
['478427A21','AUDI','A6 AVANT','F2','2018 >'],
['A68427A21','AUDI','A6 AVANT','4G-4G1','02/2011 > 2017'],
['AA71C2A21','AUDI','A7 SPORTBACK','4G-4G1','10/2010 > 2017'],
['4B71C2A21','AUDI','A7 SPORTBACK','F2','2018 >'],
['EF42F2A21','AUDI','A8','4E','2002 > 2009'],
['AE42F2A21','AUDI','A8','4H','03/2010 > 2017'],
['8052F2A21','AUDI','A8','F8','2018 >'],
['AAA818A21','AUDI','E-Tron','GE','2019 >'],
['A093C8A21','AUDI','E-Tron Sportback','GE','04/2020 >'],
['A4CD67A21','AUDI','Q2','GA','10/2016 >'],
['A22323A21','AUDI','Q3','8U-8U1','10/2011 > 2018'],
['432323A21','AUDI','Q3','F3','2019 >'],
['A8E168A21','AUDI','Q3 SPORTBACK','F3','2020 >'],
['A2AD39A21','AUDI','Q4 E-TRON','FZ','2021 >'],
['A6F353A21','AUDI','Q5','8R-8R1','11/2008 > 2016'],
['47F353A21','AUDI','Q5','FY','2017 >'],
['A06C63A21','AUDI','Q5 Hybrid','8R2','11/2008 > 2016'],
['AAFBD8A21','AUDI','Q5 SPORTBACK','FY','2021 >'],
['4F95B3A21','AUDI','Q7','4L','2006 > 2014'],
['AE95B3A21','AUDI','Q7','4L','06/2015 >'],
['AA5557A21','AUDI','Q7 E-Tron','4L','2016 >'],
['A04008A21','AUDI','Q8','4L','2018 >'],
['ACDEF3A21','AUDI','RS3','8P','2011 > 2014'],
['4DDEF3A21','AUDI','RS3','8V','2015 > 2021'],
['884714A21','AUDI','RS4','B8 (F4)','2018 >'],
['E74714A21','AUDI','RS4','B8 (8K)','2011 > 2017'],
['A0BF24A21','AUDI','RS5','B8 (8T-8F)','2011 > 2017'],
['41BF24A21','AUDI','RS5','B8 (F5)','2018 >'],
['AA1844A21','AUDI','RS6 (I SERIE)','4B','2003 > 2007'],
['A48064A21','AUDI','RS6 (II SERIE)','4F','2008 > 2012'],
['AEE874A21','AUDI','RS6 (III SERIE)','4G','2013 > 2019'],
['A0FC37A21','AUDI','RS7 Sportback','4G','2013 > 2019'],
['4376E3A21','AUDI','RSQ3','F3','2020 >'],
['A276E3A21','AUDI','RSQ3','8U','2012 > 2019'],
['AC22C4A21','AUDI','S1','8X','05/2014 > 2018'],
['A69AD4A21','AUDI','S1 SPORTBACK','8X','05/2014 > 2018'],
['E103F4A21','AUDI','S3','8V','2013 > 2019'],
['8203F4A21','AUDI','S3','GY','2020 >'],
['4103F4A21','AUDI','S3','8L','1996 > 2003'],
['8C6B05A21','AUDI','S4','B8 (F4)','2016 >'],
['AA6B05A21','AUDI','S4','B8 (8K)','03/2009 > 10/2015'],
['EB6B05A21','AUDI','S4','8E','2001 > 2007'],
['AE3C35A21','AUDI','S5','B8 (8T)','06/2007 > 09/2016'],
['A207B7A21','AUDI','S5 COUPE - SPORTBACK - CABRIO','B8 (F5)','10/2016 >'],
['841D65A21','AUDI','S6','F2','2019 >'],
['E31D65A21','AUDI','S6','4F','2004 > 12/2010'],
['A21D65A21','AUDI','S6','4G-4G1','02/2011 > 2018'],
['431D65A21','AUDI','S6','4B','1997 > 2004'],
['AC6FC7A21','AUDI','S7 Sportback','4G-4G1','2011 > 2018'],
['4D6FC7A21','AUDI','S7 Sportback','F2','2019 >'],
['A6ED95A21','AUDI','S8','4H','03/2010 > 2017'],
['88ED95A21','AUDI','S8','F8','2019 >'],
['A41138A21','AUDI','SQ2','GA','2019 >'],
['A2C9A4A21','AUDI','SQ5','8R','2012 > 2016'],
['43C9A4A21','AUDI','SQ5','FY','2017 >'],
['A89E97A21','AUDI','SQ7','4L','10/2016 >'],
['AE7948A21','AUDI','SQ8','4L','2018 >'],
['B2FFCBED91','AUDI','TT','8J','02/2007 > 11/2014 '],
['C2FFCBED91','AUDI','TT','8J (8S)','11/2014 >'],
['AABEC5A21','AUDI','TT','8N','1998 > 2006'],
['E2FFCBED91','AUDI','TT RS','8J (8S)','11/2014 >'],
['D2FFCBED91','AUDI','TT RS','8J','01/2007 > 11/2014'],
['03FFCBED91','AUDI','TTS','8J (8S)','11/2014 >'],
['AC07D52A1','BMW','i4','G4C (G26)','2022 >'],
['AA724F1A1','BMW','M2','M3(F87)','2016 > 2021'],
['8A0A141A1','BMW','M3','M3 (F80)','08/2013 > 10/2020'],
['89DFCBED91','BMW','M3 (G20,G80)','G234M','10/2020 >'],
['4D39FE1A1','BMW','M4','G234M','2021 >'],
['AC39FE1A1','BMW','M4','M3 (F82)','08/2013 > 10/2020'],
['8896251A1','BMW','Serie 1','F1H (F40)','09/2019 >'],
['A696251A1','BMW','Serie 1','1K4 (F20)','08/2011 > 2014'],
['4796251A1','BMW','Serie 1','187-1K2-1K4 (E87)','2004 > 08/2011'],
['E796251A1','BMW','Serie 1','1K4 (F20)','2015 > 2018'],
['A00F351A1','BMW','Serie 1 (3 Porte)','1K2 (F21)','08/2011 > 2014'],
['410F351A1','BMW','Serie 1 (3 Porte)','1K2 (F21)','2015 > 2018'],
['A4DF651A1','BMW','SERIE 1 CABRIO','1C','08/2011 > 2018'],
['A8A0A51A1','BMW','Serie 1 Coupe','182 (E82)','2007 > 08/2011'],
['AC71D51A1','BMW','Serie 1 M 135i','1K4 (F21)','06/2012 > 2014'],
['4D71D51A1','BMW','Serie 1 M 135i','1K4 (F21)','2015 > 2016'],
['A4979E1A1','BMW','Serie 1 M 140i','1K4 (F21)','2017 > 2019'],
['AABA161A1','BMW','Serie 2','1C (F22-F23)','2014 > 2019'],
['E523361A1','BMW','Serie 2 Active Tourer','U2AT (U06)','2022 >'],
['4523361A1','BMW','Serie 2 Active Tourer','F2AT (F45)','2017 > 2021'],
['A423361A1','BMW','Serie 2 Active Tourer','UKL-L (F45)','08/2014 > 2016'],
['AAFC552A1','BMW','SERIE 2 COUPE','G2C (G42)','2021 >'],
['A0E7062A1','BMW','SERIE 2 COUPE M240i','G2C (G42)','2021 >'],
['A89F142A1','BMW','Serie 2 GRAN COUPE','F2GC (F44)','2020 >'],
['4F8B461A1','BMW','Serie 2 Gran Tourer','F2GT (F46)','2017 >'],
['A8F3661A1','BMW','Serie 2 M 235i','1C (F22-F23)','2014 > 2016'],
['A868CE1A1','BMW','Serie 2 M 240i','1C (F22-F23)','2017 > 2019'],
['883DA61A1','BMW','Serie 3','390L(E90)','2005 > 2012'],
['C93DA61A1','BMW','Serie 3','G3L (G20)','2019 >'],
['293DA61A1','BMW','Serie 3','3L (F30)','2012 > 2018'],
['E73DA61A1','BMW','Serie 3','346 (E46)','1998 > 2005'],
['AA0ED61A1','BMW','Serie 3 Cabrio','3C (E93)','2006 > 2013'],
['AEDE071A1','BMW','SERIE 3 COUPE - CABRIO','392C(E92)','2006 > 2012'],
['4FDE071A1','BMW','SERIE 3 COUPE - CABRIO','3C','2012 > 2018'],
['A2BF371A1','BMW','Serie 3 Gran Turismo (GT)','3-V (F34)','06/2013 > 2018'],
['E1F8871A1','BMW','Serie 3 Touring','G3K (G21)','2019 >'],
['41F8871A1','BMW','Serie 3 Touring','390L(E91)','2005 > 2012'],
['A0F8871A1','BMW','Serie 3 Touring','3K - 3K-N1 (F31)','2012 > 2018'],
['A4C9B71A1','BMW','Serie 3 X-Drive','390X(E90)','2005 > 2012'],
['4D6B181A1','BMW','Serie 4 Cabrio','G3C (G23)','06/2020 >'],
['AC6B181A1','BMW','Serie 4 Cabrio','3C (F33)','02/2014 > 2019'],
['414C481A1','BMW','Serie 4 Coupe','G3C (G22)','06/2020 >'],
['A04C481A1','BMW','Serie 4 Coupe','3C (F32)','08/2013 > 2019'],
['A41D781A1','BMW','Serie 4 Gran Coupe','3C (F36)','02/2014 > 2019'],
['451D781A1','BMW','Serie 4 Gran Coupe','G4C (G26)','2021 >'],
['8AEDA81A1','BMW','Serie 5','560L(E60)','2003 > 03/2010'],
['2BEDA81A1','BMW','Serie 5','G5L (G30)','2017 >'],
['A8EDA81A1','BMW','Serie 5','5L (F10)','04/2010 > 2016'],
['A256C81A1','BMW','Serie 5 Active Hybrid','HY','04/2010 > 2016'],
['A0FFCBED91','BMW','Serie 5 AWD 4X4 (E60)','560X','07/2003 > 03/2010'],
['A627F81A1','BMW','Serie 5 Gran Turismo (GT)','GT - K-N1 (F07)','11/2009 > 2016'],
['4157322A1','BMW','Serie 5 M-Performance','G5L (G30)','2017 >'],
['4528622A1','BMW','Serie 5 M-Performance Touring','G5K (G31)','2017 >'],
['A460491A1','BMW','Serie 5 Touring','5K - K-N1 (F11)','04/2010 > 2016'],
['4560491A1','BMW','Serie 5 Touring','G5K (G31)','2017 >'],
['4931791A1','BMW','Serie 5 X-Drive','G5L (G30)','2017 >'],
['49F8922A1','BMW','Serie 5 X-Drive M-Performance','G5L (G30)','2017 >'],
['4D02A91A1','BMW','Serie 5 X-Drive Touring','G5K (G31)','2017 >'],
['4DC9C22A1','BMW','Serie 5 X-Drive Touring M-Performance','G5K (G31)','2017 >'],
['AE1C1A1A1','BMW','Serie 6 Cabrio','6C','2011 > 2017'],
['A2FC4A1A1','BMW','Serie 6 Coupe','6C','2011 > 2017'],
['A6A11F1A1','BMW','Serie 6 Gran Turismo (GT)','G6GT (G32)','2018 >'],
['A407CA1A1','BMW','Serie 7','701 - 7L','10/2008 > 09/2015'],
['AE6FDA1A1','BMW','Serie 7 (730 - 740)','7L (G11-G12)','10/2015 > 2022'],
['A0AAF22A1','BMW','Serie 7 (730 - 740) M-Performance','7L (G11-G12)','10/2015 > 2022'],
['A8150E1A1','BMW','SERIE 7 (750)','7L (G11-G12)','10/2015 > 2022'],
['AA03132A1','BMW','Serie 7 (750) M-Performance','7L (G11-G12)','10/2015 > 2022'],
['A8D7FA1A1','BMW','Serie 7 Active Hybrid','HY - 3-HY','10/2008 > 09/2015'],
['41895B1A1','BMW','Serie 8','G8C (G15)','10/2018 >'],
['3EDFCBED91','BMW','Serie 8 Cabrio (G14, F91)','G8C (G14)','01/2019 >'],
['4EDFCBED91','BMW','Serie 8 Gran Coupe (G16, F93)','G8C (G16)','10/2019 >'],
['E55A8B1A1','BMW','X1','F1X (F48)','2017 > 2021'],
['A45A8B1A1','BMW','X1','X1 - X1-N1 - X-N1 (E84)','01/2010 > 2014'],
['455A8B1A1','BMW','X1','UKL-L (F48)','2015 > 2016'],
['A4EA5F1A1','BMW','X2','F2X (F39)','2018 >'],
['492BBB1A1','BMW','X3','X83','2003 > 10/2010'],
['A82BBB1A1','BMW','X3','X3 - X-N1 (F25)','11/2010 > 2017'],
['E92BBB1A1','BMW','X3','G3X (G01)','2018 >'],
['4DFBEB1A1','BMW','X4','G4X (G02)','2018 >'],
['ACFBEB1A1','BMW','X4','X3 (F26)','06/2014 > 2017'],
['A4F01D1A1','BMW','Z3','R/C','1995 > 2002'],
['E9C14D1A1','BMW','Z4','G4Z (G29)','2019 >'],
['A8C14D1A1','BMW','Z4','Z89-ZR','04/2009 > 2018'],
['49C14D1A1','BMW','Z4','Z85','2002 > 03/2009'],
['A4CEE32A1','BMW','Z4 M-PERFORMANCE','G4Z (G29)','2019 >'],
['AC927D1A1','BMW','Z4-M Coupe','M85','2006 > 2009'],
['A073AD1A1','BMW','Z4-M Roadster','M85','2006 > 2009'],
['AA438AF82','CHEVROLET (Former DAEWOO)','AVEO 4H','KL1T','06/2011 >'],
['ACF38CF82','CHEVROLET (Former DAEWOO)','AVEO 5H','KL1T','06/2011 >'],
['A88CCAF82','CHEVROLET (Former DAEWOO)','CRUZE (VERSIONE BENZINA)','KL1J','04/2009 >'],
['AA964BF82','CHEVROLET (Former DAEWOO)','KALOS','KLAS','2002 >'],
['A4522CF82','CHEVROLET (Former DAEWOO)','SPARK','CHIS-KL1M','12/2009 >'],
['ACF9A4BC2','CHRYSLER','PT CRUISER','PT','2000 >'],
['4762C4BC2','CHRYSLER','SEBRING','JS','06/2007 >'],
['04FFCBED91','CITROEN - DS','BERLINGO','7*','7'],
['14FFCBED91','CITROEN - DS','BERLINGO','E','06/2018 >'],
['A23E3E603','CITROEN - DS','C-CROSSER','V','01/2007 > 2013'],
['41778E603','CITROEN - DS','C1','P','2014 >'],
['A0778E603','CITROEN - DS','C1','P - PG','2005 > 2013'],
['E548BE603','CITROEN - DS','C3','S','2010 > 2016'],
['8648BE603','CITROEN - DS','C3','S','2017 >'],
['AEA0DE603','CITROEN - DS','C3 PICASSO','SH','2009 > 2016'],
['ACE91F603','CITROEN - DS','C4','N','12/2010 > 2020'],
['A6523F603','CITROEN - DS','C4 Aircross','B','2012 >'],
['4B236F603','CITROEN - DS','C4 PICASSO / C4 SPACETOURER','U','11/2006 > 2012'],
['AA236F603','CITROEN - DS','C4 PICASSO / C4 SPACETOURER','3','06/2013 >'],
['A00852703','CITROEN - DS','C5 AIRCROSS','A','2018 >'],
['490331703','CITROEN - DS','NEMO','225L','2008 >'],
['A80331703','CITROEN - DS','NEMO','A','2008 >'],
['AAE2F15DF','CUPRA','ATECA (221Kw)','5FP','2019 >'],
['A294525DF','CUPRA','BORN','K1','2021 >'],
['A82C325DF','CUPRA','FORMENTOR (NOT BREMBO BRAKES)','KM','2020 >'],
['ACFC625DF','CUPRA','FORMENTOR VZ5 (287Kw BREMBO BRAKES)','KM','2021 >'],
['1EDFCBED91','CUPRA','LEON','KL','11/2020 >'],
['AA2987243','DACIA','DOKKER - DOKKER STEPWAY','SD','07/2012 >'],
['EFDFCBED91','DACIA','DUSTER','SR','01/2018 >'],
['A491A7243','DACIA','DUSTER','SD - SR','03/2010 >'],
['AEF9B7243','DACIA','LODGY - LODGY STEPWAY','SD','06/2012 >'],
['E2EFCBED91','DACIA','LOGAN I - II','SD - SR','09/2004 > 12/2020'],
['F2EFCBED91','DACIA','LOGAN MCV - MCV STEPWAY','SD - SR','02/2007 > 12/2020'],
['4D3308243','DACIA','SANDERO','DJF','2021 >'],
['AC3308243','DACIA','SANDERO','SD - SR','05/2008 > 2020'],
['A6AB18243','DACIA','SANDERO STEPWAY','SD - SR','2009 > 2020'],
['47AB18243','DACIA','SANDERO STEPWAY','DJF','2021 >'],
['A01438243','DACIA','SPRING','DBG','2021 >'],
['453E41E73','DAIHATSU','CHARADE','XP9','2011 >'],
['A80F71E73','DAIHATSU','CUORE','L2 / L7','1998 > 2006'],
['490F71E73','DAIHATSU','CUORE','L27','2007 >'],
['ACDFA1E73','DAIHATSU','MATERIA','M4','2007 >'],
['A648C1E73','DAIHATSU','SIRION','M3','2005 >'],
['37DFCBED91','DODGE','AVENGER','JS','06/2007 >'],
['32FFCBED91','DS','DS3','S*','S'],
['42FFCBED91','DS','DS3 Cabrio','S*','S'],
['72FFCBED91','DS','DS4','F','02/2021 > '],
['62FFCBED91','DS','DS4/DS4 Crossback','N','03/2011 > 05/2018'],
['82FFCBED91','DS','DS5','K','KF'],
['92FFCBED91','DS','DS7/DS7 Crossback','J','11/2017 >'],
['A6088BC64','FIAT','124 SPIDER','NF','05/2016 >'],
['A4FD0BC64','FIAT','500','312','07/2007 >'],
['AE562BC64','FIAT','500C','312','2009 >'],
['ACE23CC64','FIAT','500e','FA1','2020 >'],
['A2375BC64','FIAT','500X','334','2015 >'],
['AE1918C64','FIAT','BRAVO','198','02/2007 > 2014'],
['A2F948C64','FIAT','CROMA','194','2005 > 2010'],
['AE036AC64','FIAT','FIORINO (M1) - QUBO (M1)','225 - 225L','2008 >'],
['A08659C64','FIAT','FIORINO (N1)','225 - 225L','2008 >'],
['A45789C64','FIAT','GRANDE PUNTO','199','2005 > 2018'],
['AEBF99C64','FIAT','IDEA','350','2004 > 2010'],
['A6610AC64','FIAT','PALIO','178','1997 > 2005'],
['A0D91AC64','FIAT','PANDA','312','01/2012 >'],
['41D91AC64','FIAT','PANDA','169','2003 > 2011'],
['A28A1CC64','FIAT','PANDA CROSS','312','2012 >'],
['4B323AC64','FIAT','PUNTO','188','1999 > 2005'],
['A4AA4AC64','FIAT','PUNTO EVO','199','2009 > 2012'],
['AC4CAAC64','FIAT','SEDICI','FY','2005 > 2013'],
['AAE4918A4','FORD','B-MAX','JK8','09/2012 >'],
['A45DA18A4','FORD','C-MAX','DXA','11/2010 >'],
['455DA18A4','FORD','C-MAX','DM2','2003 > 10/2010'],
['A82ED18A4','FORD','ECOSPORT','JK8','2013 >'],
['AAC8268A4','FORD','EDGE (O.E. ALLOY WHEELS)','SBF','2015 >'],
['ACD2A68A4','FORD','EDGE (O.E. STEEL WHEELS)','SBF','2015 >'],
['A296F18A4','FORD','ESCAPE','1EZ-1EZR','2003 >'],
['EF09828A4','FORD','FIESTA','JHH - JGH','2017 >'],
['AEEC178A4','FORD','FIESTA ST','JHH','2018 >'],
['4971A28A4','FORD','FOCUS','DA3 - DB3','2003 > 2010'],
['E971A28A4','FORD','FOCUS','DYB','2011 > 2017'],
['8A71A28A4','FORD','FOCUS','DEH','2018 >'],
['A855378A4','FORD','FOCUS ACTIVE','DEH','2019 >'],
['A2E9B28A4','FORD','FOCUS RS','DA3-RS','09/2008 > 2015'],
['43E9B28A4','FORD','FOCUS RS','DYB-RS','2016 >'],
['4D42D28A4','FORD','FOCUS ST','DYB','2011 > 2017'],
['ED42D28A4','FORD','FOCUS ST','DEH','2019 >'],
['AA8B138A4','FORD','GALAXY II SERIE','WA6','06/2006 > 09/2015'],
['A4F3338A4','FORD','GALAXY III SERIE (O.E. ALLOY WHEELS)','WA6','10/2015 >'],
['A27A868A4','FORD','GALAXY III Serie (O.E. STEEL WHEELS)','WA6','10/2015 >'],
['AE5C438A4','FORD','GRAND C-MAX','DXA','11/2010 >'],
['A23D738A4','FORD','KA (II SERIE)','RU8','2009 > 2015'],
['A802768A4','FORD','KA+','KAF','09/2016 >'],
['AC95938A4','FORD','KUGA','DM2','05/2008 > 2012'],
['A60EA38A4','FORD','KUGA II','DM2','2013 > 2019'],
['A2CD478A4','FORD','KUGA III','DFK','2020 >'],
['A076C38A4','FORD','MAVERICK','1N2-1N2R','2003 >'],
['AADED38A4','FORD','MONDEO','BA7','06/2007 > 2014'],
['8CDED38A4','FORD','MONDEO','BA7','2015 >'],
['EBDED38A4','FORD','MONDEO','B4Y-B5Y','1999 > 05/2007'],
['AADFCBED91','FORD','MONDEO HYBRID 2020','BA7H'],
['A8A8F78A4','FORD','MUSTANG MACH-E','LSK','2021 >'],
['4B22A48A4','FORD','PUMA','J2K','2020 >'],
['E0EFCBED91','FORD','PUMA ST (200CV)','J2K','01/2020 >'],
['A86BE48A4','FORD','S-MAX I SERIE','WA6','06/2006 > 09/2015'],
['A2D3058A4','FORD','S-MAX II SERIE (O.E. ALLOY WHEELS)','WA6','10/2015 >'],
['AA1CE68A4','FORD','S-MAX II Serie (O.E. STEEL WHEELS)','WA6','10/2015 >'],
['B1FFCBED91','FORD','TRANSIT/TOURNEO CONNECT','PJ2-PU2','10/2013 > 05/2018'],
['C1FFCBED91','FORD','TRANSIT/TOURNEO CONNECT','PJ2-PU2','06/2018 > 02/2022'],
['E1FFCBED91','FORD','TRANSIT/TOURNEO COURIER','JU2 - JN8','05/2014 >'],
['AACA9EA55','HONDA','ACCORD','C','2003 > 2015'],
['47DFCBED91','HONDA','ACCORD','CU1,CU2,CU3','2008 > 2015'],
['AAB4E0B55','HONDA','CIVIC','FC - FK','2017 > 2021'],
['3FDFCBED91','HONDA','CIVIC (4 FORI)','E..',' M..'],
['A27CFEA55','HONDA','CIVIC 5H','F','2002 > 2016'],
['3BDFCBED91','HONDA','CIVIC TYPE R','EP3-EP4','11/2001 > 01/2006'],
['2BDFCBED91','HONDA','CIVIC TYPE R','FN1,FN2,FN3','04/2007 > 12/2011'],
['4BDFCBED91','HONDA','CIVIC TYPE S','FN1,FN2,FN3,FN4','04/2007 > 12/2011'],
['EDD41FA55','HONDA','CR-V - CR-V HYBRID','RE5-RE6-RE7','2007 > 2017'],
['4DD41FA55','HONDA','CR-V - CR-V HYBRID','RD8-RD9','2005 > 2007'],
['8ED41FA55','HONDA','CR-V - CR-V HYBRID','RW (RT)','2018 >'],
['A64D2FA55','HONDA','CR-Z','ZF1','03/2010 >'],
['A26641B55','HONDA','E','ZC','2019 >'],
['A4867FA55','HONDA','FR-V','BE1-BE3-BE5','2004 > 2010'],
['4FEE8FA55','HONDA','HR-V','GH1-GH2-GH3-GH4','2000 > 2006'],
['AEEE8FA55','HONDA','HR-V','RU','10/2015 > 2020'],
['4D28DFA55','HONDA','JAZZ','GK','10/2015 > 2019'],
['ED28DFA55','HONDA','JAZZ','GD1 - GE3','2002 > 09/2008'],
['AA04F12D5','HYUNDAI','ACCENT','MC - MCT','04/2006 > 2010'],
['A08F662D5','HYUNDAI','BAYON','BC3','2021 >'],
['43B5522D5','HYUNDAI','COUPE','GK','2001 > 2009'],
['E195242D5','HYUNDAI','i10','AC3','2020 >'],
['A095242D5','HYUNDAI','i10','IA','11/2013 > 2019'],
['4BFD342D5','HYUNDAI','i20','GB','2014 > 2019'],
['EBFD342D5','HYUNDAI','i20','BC3','2020 >'],
['A6C3952D5','HYUNDAI','i20 Active','GB','2016 > 2019'],
['4566542D5','HYUNDAI','i30','FD','07/2007 > 2011'],
['A466542D5','HYUNDAI','i30','GDH','2012 > 2016'],
['E566542D5','HYUNDAI','i30','PDE','2017 >'],
['A8DD062D5','HYUNDAI','i30 N','PDE','2017 >'],
['4FCE642D5','HYUNDAI','i30 WAGON','PDE','2017 >'],
['A2AF942D5','HYUNDAI','i40','VF','07/2011 >'],
['A40DD52D5','HYUNDAI','IONIQ','AE','2016 >'],
['A25CD32D5','HYUNDAI','iX20','JC','11/2010 >'],
['ACB4F32D5','HYUNDAI','iX35','EL - LM','03/2010 > 2015'],
['AE65F52D5','HYUNDAI','KONA','OS','2018 >'],
['ACAE362D5','HYUNDAI','KONA ELECTRIC VEHICLE','OS','2019 >'],
['A246262D5','HYUNDAI','NEXO','FE','2018 >'],
['A0E8E42D5','HYUNDAI','SONATA','NF','2005 > 2018'],
['4F12352D5','HYUNDAI','TUCSON','JM','2004 > 2009'],
['AE12352D5','HYUNDAI','TUCSON','TL..','09/2015 > 2020'],
['EF12352D5','HYUNDAI','TUCSON','NX4e','2021 >'],
['A88A452D5','HYUNDAI','VELOSTER','FS','09/2011 >'],
['A83DACD06','INFINITI','QX30','H15','2016 >'],
['AA70FA0C6','JAGUAR','E-PACE','DF','2018 >'],
['AC37AA0C6','JAGUAR','F-PACE','DC','2016 >'],
['A4E80B0C6','JAGUAR','i-PACE','DH','2018 >'],
['A4FEB80C6','JAGUAR','S-TYPE','CCX','04/1999 >'],
['AE57D80C6','JAGUAR','X-TYPE','CF1','2001 >'],
['A8CFE80C6','JAGUAR','XE','JA','06/2015 >'],
['AC90290C6','JAGUAR','XF','CC9','2008 > 2015'],
['4D90290C6','JAGUAR','XF','JB','2016 >'],
['A6AFBA0C6','JAGUAR','XF SPORTBRAKE','CC9','2008 > 2015'],
['A609390C6','JAGUAR','XJ','N*3','2003 > 2008'],
['4B2352CF6','JEEP','CHEROKEE','KL','04/2014 >'],
['4FF382CF6','JEEP','COMPASS','MX','08/2017 >'],
['A01EF2CF6','JEEP','RENEGADE','BU','09/2014 >'],
['AACFFB737','KIA','CARENS','FG','12/2006 > 2012'],
['EBCFFB737','KIA','CARENS','RP','2013 >'],
['EF903C737','KIA','CEED - CEED SPORTWAGON','CD','2018 >'],
['AE903C737','KIA','CEED - CEED SPORTWAGON','ED','2007 > 2011'],
['4F903C737','KIA','CEED - CEED SPORTWAGON','JD','2012 > 2017'],
['AC700E737','KIA','NIRO','DE','2016 > 2021'],
['A8F29E737','KIA','NIRO ELECTRIC VEHICLE','DE','2016 > 2021'],
['AA13CC737','KIA','OPIRUS','LD','2003 >'],
['868BDC737','KIA','OPTIMA','JF','2016 >'],
['E58BDC737','KIA','OPTIMA','TF','2012 > 2015'],
['EFE3FC737','KIA','PICANTO','JA','2017 >'],
['2DEFCBED91','KIA','PRO CEED','JD','02/2013 > 08/2018'],
['43C42D737','KIA','PRO CEED','CD','2019 >'],
['4D2D3D737','KIA','RIO','UB','09/2011 > 2016'],
['ED2D3D737','KIA','RIO','DE','2005 > 2010'],
['8E2D3D737','KIA','RIO','YB','2017 >'],
['E5DE9D737','KIA','SOUL','SK3','2018 >'],
['A4DE9D737','KIA','SOUL','AM','2009 > 2013'],
['45DE9D737','KIA','SOUL','PS','2014 > 2017'],
['8047BD737','KIA','SPORTAGE','QL..','2016 > 2021'],
['4F37BD737','KIA','SPORTAGE','SL - SLS','09/2010 > 2013'],
['EF37BD737','KIA','SPORTAGE','JE - JES','2004 > 08/2010'],
['AAB94E737','KIA','STONIC','YB','09/2017 >'],
['A218ED737','KIA','VENGA','YN - YNS','02/2010 >'],
['A4226E737','KIA','XCEED','CD','2020 >'],
['A68BEFEA7','LANCIA','MUSA','350','2004 >'],
['A89560FA7','LANCIA','YPSILON','312','06/2011 >'],
['499560FA7','LANCIA','YPSILON','843','2003 > 2010'],
['A090B9AE7','LAND ROVER','DEFENDER','LE','2020 >'],
['A41E19AE7','LAND ROVER','DISCOVERY III','LA','2004 > 03/2009'],
['AE7639AE7','LAND ROVER','DISCOVERY IV','LA','04/2009 > 2014'],
['A8EE49AE7','LAND ROVER','DISCOVERY SPORT','LC','03/2015 >'],
['A62899AE7','LAND ROVER','DISCOVERY V','LR','05/2017 >'],
['AAAFC34AB','LAND ROVER','EVOQUE','LV','09/2011 > 2018'],
['4BAFC34AB','LAND ROVER','EVOQUE','LZ','2019 >'],
['A09A744AB','LAND ROVER','EVOQUE CONVERTIBLE','LV','2016 >'],
['ACBF79AE7','LAND ROVER','FREELANDER II','LF','01/2007 >'],
['AE70044AB','LAND ROVER','RANGE ROVER III Serie','LM','2002 > 2012'],
['A8E8144AB','LAND ROVER','RANGE ROVER IV Serie','LG','2013 > 2021'],
['A622644AB','LAND ROVER','RANGE ROVER SPORT II Serie','LW','04/2013 > 2021'],
['AAF2944AB','LAND ROVER','VELAR','LY','07/2017 >'],
['AA42B2628','LEXUS','CT-200H','A10(A)','10/2010 >'],
['A23126628','LEXUS','ES300H','XZ1L','2019 >'],
['45BAC2628','LEXUS','GS 300','S19 (A)','2005 >'],
['4F13E2628','LEXUS','GS 430','S19 (A)','2005 >'],
['AA9573628','LEXUS','GS 460','S19 (a)','2005 >'],
['AE66A3628','LEXUS','IS200','XE1','1998 > 2004'],
['A8DEB3628','LEXUS','IS220','XE2(A)','2005 >'],
['ACAFE3628','LEXUS','IS250','XE2(A)','2005 >'],
['A08024628','LEXUS','IS300','XE1','1998 > 2004'],
['AAE834628','LEXUS','IS300H','XE2(A)','06/2013 >'],
['A0D3E4628','LEXUS','NX','AZ1','10/2014 > 2021'],
['A6BE85628','LEXUS','RC 300H - RC200T','XC1','2016 >'],
['AC4675628','LEXUS','SC430','Z4','2000 >'],
['A8C806628','LEXUS','UX','ZA1','2019 >'],
['EF757EB89','MAZDA','2','DJ1','2015 > 2021'],
['4F757EB89','MAZDA','2','DE','10/2007 > 2014'],
['E9ED8EB89','MAZDA','3','BL(BM)','2013 > 2018'],
['A8ED8EB89','MAZDA','3','BL','04/2009 > 2012'],
['8AED8EB89','MAZDA','3','BP','2019 >'],
['49ED8EB89','MAZDA','3','BK','2004 > 03/2009'],
['A256AEB89','MAZDA','323','B','1990 > 2003'],
['4DBEBEB89','MAZDA','5','CR1','2005 > 09/2010'],
['ACBEBEB89','MAZDA','5','CW','10/2010 >'],
['E727DEB89','MAZDA','6','GH','2008 > 2012'],
['8827DEB89','MAZDA','6','GJ-GH','2013 >'],
['A627DEB89','MAZDA','6','G','2002 > 2007'],
['AEDEECB89','MAZDA','CX-3','DJ1','06/2015 >'],
['AAF70FB89','MAZDA','CX-30','DM','08/2019 >'],
['A8470DB89','MAZDA','CX-5','KE - GH','05/2012 > 2016'],
['49470DB89','MAZDA','CX-5','KF','2017 >'],
['A2BF1DB89','MAZDA','CX-7','ER','10/2007 >'],
['A4602FB89','MAZDA','MX-30','DR','08/2020 >'],
['45C99DB89','MAZDA','MX-5','NC1 - NC1E','2005 > 2014'],
['E5C99DB89','MAZDA','MX-5','ND','2015 >'],
['A4C99DB89','MAZDA','MX-5','NB - NBD','1998 > 05/2005'],
['A203EDB89','MAZDA','RX8','SE','2003 >'],
['A6D31EB89','MAZDA','TRIBUTE','EP','2001 >'],
['AAAA667C9','MERCEDES-BENZ','A-KLASSE','176-245G','09/2012 > 2017'],
['8CAA667C9','MERCEDES-BENZ','A-KLASSE','F2A (177)','2018 >'],
['EBAA667C9','MERCEDES-BENZ','A-KLASSE','169','2004 > 2012'],
['A413867C9','MERCEDES-BENZ','A-KLASSE AMG','176 AMG - 245G AMG','2013 > 2017'],
['A0A0018C9','MERCEDES-BENZ','A35 AMG','F2A AMG (177)','2019 >'],
['4F7B967C9','MERCEDES-BENZ','B-KLASSE','245-245G','2005 > 10/2011'],
['AE7B967C9','MERCEDES-BENZ','B-KLASSE','245G (246)','11/2011 > 2018'],
['EF7B967C9','MERCEDES-BENZ','B-KLASSE','F2B (247)','2019 >'],
['A8E3B67C9','MERCEDES-BENZ','B-KLASSE ELEKTRIC DRIVE','245G (246)','2014 > 2018'],
['A25CC67C9','MERCEDES-BENZ','C-KLASSE','204(205)','01/2014 > 2020'],
['435CC67C9','MERCEDES-BENZ','C-KLASSE','204','04/2007 > 01/2014'],
['255CC67C9','MERCEDES-BENZ','C-KLASSE','R2CW (206)','2021 >'],
['845CC67C9','MERCEDES-BENZ','C-KLASSE','203','2002 > 2007'],
['E35CC67C9','MERCEDES-BENZ','C-KLASSE','202','1993 > 2001'],
['AC0DD38C9','MERCEDES-BENZ','C-KLASSE ALL TERRAIN','R2CS (206K)','2022 >'],
['4DB4E67C9','MERCEDES-BENZ','C-KLASSE AMG','204 AMG (205)','2015 > 2020'],
['ACB4E67C9','MERCEDES-BENZ','C-KLASSE AMG','204 AMG','04/2007 > 01/2014'],
['4195177C9','MERCEDES-BENZ','C-KLASSE S.W.','204K','04/2007 > 01/2014'],
['A095177C9','MERCEDES-BENZ','C-KLASSE S.W.','204K (205)','01/2014 > 2020'],
['E195177C9','MERCEDES-BENZ','C-KLASSE S.W.','R2CS (206K)','2021 >'],
['43AF877C9','MERCEDES-BENZ','CL-KLASSE','215','1999 > 2005'],
['A2AF877C9','MERCEDES-BENZ','CL-KLASSE','216','09/2006 > 2013'],
['4B41F77C9','MERCEDES-BENZ','CLA','F2CLA (118)','2019 >'],
['AA41F77C9','MERCEDES-BENZ','CLA','117-245G','2013 > 2018'],
['A4B9087C9','MERCEDES-BENZ','CLA AMG','117 AMG-245G','2013 > 2018'],
['AE12287C9','MERCEDES-BENZ','CLA SHOOTING BRAKE','117-245G','2015 > 2018'],
['4F12287C9','MERCEDES-BENZ','CLA SHOOTING BRAKE','F2CLA (118)','2020 >'],
['A6DE628C9','MERCEDES-BENZ','CLA35 AMG','F2CLA AMG (118)','2020 >'],
['A88A387C9','MERCEDES-BENZ','CLC-KLASSE','203CL','07/2008 > 2011'],
['4D5B687C9','MERCEDES-BENZ','CLK-KLASSE','209','2002 > 2010'],
['AC5B687C9','MERCEDES-BENZ','CLK-KLASSE','208','1997 > 2002'],
['A03C987C9','MERCEDES-BENZ','CLS','218','11/2010 > 2017'],
['413C987C9','MERCEDES-BENZ','CLS','219','2004 > 10/2010'],
['4B94B87C9','MERCEDES-BENZ','CLS AMG','219 AMG','2004 > 10/2010'],
['AE9C3E7C9','MERCEDES-BENZ','CLS Shooting Brake','218','2013 > 2017'],
['A8DDF87C9','MERCEDES-BENZ','E-KLASSE','212','03/2009 > 2015'],
['2BDDF87C9','MERCEDES-BENZ','E-KLASSE','212 (213)','2016 >'],
['8ADDF87C9','MERCEDES-BENZ','E-KLASSE','211','2002 > 03/2009'],
['E9DDF87C9','MERCEDES-BENZ','E-KLASSE','210','1995 > 2002'],
['AC294F7C9','MERCEDES-BENZ','E-KLASSE All Terrain','R1ES (213)','2017 >'],
['4717497C9','MERCEDES-BENZ','E-KLASSE CABRIO','R1EC (238)','2017 >'],
['A617497C9','MERCEDES-BENZ','E-KLASSE CABRIO','207','03/2009 > 2016'],
['AAE7797C9','MERCEDES-BENZ','E-KLASSE COUPE','207','03/2009 > 2016'],
['4BE7797C9','MERCEDES-BENZ','E-KLASSE COUPE','R1EC (238)','2017 >'],
['AA5CD18C9','MERCEDES-BENZ','E-KLASSE HYBRID','212 (213)','2019 >'],
['AEB8A97C9','MERCEDES-BENZ','E-KLASSE S.W.','212K','03/2009 > 2015'],
['4FB8A97C9','MERCEDES-BENZ','E-KLASSE S.W.','R1ES (213)','2016 >'],
['AAF2638C9','MERCEDES-BENZ','EQA','F2B (243)','2021 >'],
['AEC3938C9','MERCEDES-BENZ','EQB','F2B (243)','2021 >'],
['A471318C9','MERCEDES-BENZ','EQC','204X (293)','2019 >'],
['476A0A7C9','MERCEDES-BENZ','GL-KLASSE','166','10/2012 > 2015'],
['A66A0A7C9','MERCEDES-BENZ','GL-KLASSE','164G','10/2006 > 2011'],
['AA3B3A7C9','MERCEDES-BENZ','GLA','245G','2014 > 2019'],
['4B3B3A7C9','MERCEDES-BENZ','GLA','F2B (247)','2020 >'],
['A4A35A7C9','MERCEDES-BENZ','GLA AMG','245G AMG','2014 > 2019'],
['A8E8E28C9','MERCEDES-BENZ','GLA35 AMG','F2B AMG (247)','2020 >'],
['A0F3C18C9','MERCEDES-BENZ','GLB','F2B (247)','2020 >'],
['A251038C9','MERCEDES-BENZ','GLB35 AMG','F2B AMG (247)','2020 >'],
['AE0C6A7C9','MERCEDES-BENZ','GLC','204X','2015 > 2022'],
['4F0C6A7C9','MERCEDES-BENZ','GLC','R2CGLC (X254)','2022 >'],
['A0B6BE7C9','MERCEDES-BENZ','GLC AMG 43 - GLC COUPE AMG 43','204X','2016 > 2022'],
['A64E9E7C9','MERCEDES-BENZ','GLC Coupe','204X','2016 > 2022'],
['A2EC9A7C9','MERCEDES-BENZ','GLE SUV','166 (166)','08/2015 > 2018'],
['A6BDCA7C9','MERCEDES-BENZ','GLK','204X','2008 > 2015'],
['A063FD7C9','MERCEDES-BENZ','GLS','166','2016 > 2018'],
['4B8EFA7C9','MERCEDES-BENZ','M-KLASSE','166','11/2011 > 2015'],
['EB8EFA7C9','MERCEDES-BENZ','M-KLASSE','164','2005 > 10/2011'],
['AA8EFA7C9','MERCEDES-BENZ','M-KLASSE','163','< 2005'],
['A4F61B7C9','MERCEDES-BENZ','M-KLASSE AMG','166 AMG','11/2011 > 2015'],
['88019B7C9','MERCEDES-BENZ','S-KLASSE','221','2005 > 2012'],
['A6019B7C9','MERCEDES-BENZ','S-KLASSE','221 (222)','06/2013 > 2020'],
['E7019B7C9','MERCEDES-BENZ','S-KLASSE','220','1998 > 2005'],
['29019B7C9','MERCEDES-BENZ','S-KLASSE','R2S (223)','2021 >'],
['4179AB7C9','MERCEDES-BENZ','S-KLASSE AMG','221 AMG','2005 > 2012'],
['A079AB7C9','MERCEDES-BENZ','S-KLASSE AMG','221 AMG (222 AMG)','06/2013 > 2020'],
['4FA2FB7C9','MERCEDES-BENZ','SL-KLASSE','230','2001 > 2010'],
['EFA2FB7C9','MERCEDES-BENZ','SL-KLASSE','231','2011 >'],
['A81B0C7C9','MERCEDES-BENZ','SL-KLASSE AMG','230 AMG','2001 > 2010'],
['AC82CD7C9','MERCEDES-BENZ','SLC-KLASSE','172','2016 >'],
['E7545C7C9','MERCEDES-BENZ','SLK-KLASSE','172','2011 >'],
['A6545C7C9','MERCEDES-BENZ','SLK-KLASSE','170','< 2004'],
['47545C7C9','MERCEDES-BENZ','SLK-KLASSE','171','2004 > 2010'],
['AC3FFC7C9','MERCEDES-BENZ','V-KLASSE 447 (VIANO 447)','639/2 - 639/4 - 639/5','2014 >'],
['A0103D7C9','MERCEDES-BENZ','VIANO','639','08/2003 > 2013'],
['A4E06D7C9','MERCEDES-BENZ','VITO (M1)','639','08/2003 > 2013'],
['4F497D7C9','MERCEDES-BENZ','VITO 447 (N1)','639/2 - 639/4 - 639/5','2014 >'],
['A8B19D7C9','MERCEDES-BENZ','VITO TOURER 447 (M1)','639/2 - 639/4 - 639/5','2014 >'],
['A2F87030A','MG','HS - RX6 - EHS','AS23P-L','2021 >'],
['A032C030A','MG','MG5 (ELECTRIC VEHICLE)','EP22-L','2022 >'],
['A8806030A','MG','ZS EV (ELECTRIC VEHICLE)','ZS1 - SZS1 - MZS1','2020 >'],
['42EFCBED91','MINI','CLUBMAN (F54)','FMX','UKL-L'],
['82EFCBED91','MINI','COOPER CABRIO','UKL-L','FMCA (F57)'],
['A0C8BCE3A','MINI','COOPER SE','FML2E (F56)','2020 >'],
['4970DAE3A','MINI','COUNTRYMAN','FMX (F60)','2017 >'],
['A650ACE3A','MINI','COUNTRYMAN SE HYBRID','FMX (F60)','2017 >'],
['A2E8EAE3A','MINI','COUPE','UKL/C','2011 > 2013'],
['72EFCBED91','MINI','MINI (F55,F56)','FML2','FML4'],
['32EFCBED91','MINI','MINI (F55,F56)','UKL-L','02/2014 > 2016'],
['02EFCBED91','MINI','MINI (R50,R53)','R50, MINI','09/2001 > 11/2006'],
['12EFCBED91','MINI','MINI (R55,R56,R57)','UKL-C,/K,/L,/B-L','10/2006 > 02/2014'],
['AA8073A7A','MITSUBISHI','ASX','GA0','07/2010 > 2022'],
['AE51A3A7A','MITSUBISHI','CARISMA','DA0','06/1999 >'],
['AC8436A7A','MITSUBISHI','ECLIPSE CROSS','GK0','2018 >'],
['A28594A7A','MITSUBISHI','GRANDIS','NA0W','2004 >'],
['41CED4A7A','MITSUBISHI','LANCER','CY0','2008 >'],
['A0CED4A7A','MITSUBISHI','LANCER','CS0','2003 > 2007'],
['AEF725A7A','MITSUBISHI','OUTLANDER','CU0W','2003 > 2006'],
['A86045A7A','MITSUBISHI','OUTLANDER II','CW0-CWB','01/2007 > 2011'],
['A2D855A7A','MITSUBISHI','OUTLANDER III','CW0-GF0','2012 >'],
['A22C16A7A','MITSUBISHI','SPACE STAR','A00','04/2013 >'],
['4CDFCBED91','MITSUBISHI','SPACE WAGON','N50','09/1998 > 12/2005'],
['A4953D5BA','NISSAN','ALMERA TINO','V10','2000 > 2002'],
['A4E8FD5BA','NISSAN','JUKE','F15','09/2010 > 2019'],
['A8B92E5BA','NISSAN','JUKE NISMO RS','F15','2012 > 2019'],
['43224E5BA','NISSAN','LEAF','ZE1','2018 >'],
['4F94DE5BA','NISSAN','NOTE','E12','2014 >'],
['AE94DE5BA','NISSAN','NOTE','E11','2006 > 08/2013'],
['A699FF5BA','NISSAN','PRIMERA','P12','2001 >'],
['A002106BA','NISSAN','PULSAR','C13','10/2014 >'],
['EB6A206BA','NISSAN','QASHQAI','J12','2021 >'],
['AA6A206BA','NISSAN','QASHQAI','J10','02/2007 > 2013'],
['4B6A206BA','NISSAN','QASHQAI','J11','2014 > 2020'],
['4155D06BA','NISSAN','X-TRAIL','T30','2001 > 02/2007'],
['A055D06BA','NISSAN','X-TRAIL','T31','03/2007 > 2013'],
['E155D06BA','NISSAN','X-TRAIL','T32','2014 > 2021'],
['AAC9C61FA','OPEL','ADAM','S-D','2013 >'],
['A432E61FA','OPEL','ADAM S','S-D','2013 >'],
['EF9AF61FA','OPEL','AGILA','H-B','2008 >'],
['0CEFCBED91','OPEL','ASTRA G','T98 (4 e 5 FORI)','02/1998 > 02/2004'],
['EBEFCBED91','OPEL','ASTRA H','A-H/C (5 FORI)','03/2004 > 12/2010'],
['DBEFCBED91','OPEL','ASTRA H','A-H (4 FORI)','03/2004 > 12/2010'],
['2CEFCBED91','OPEL','ASTRA H GTC','A-H/C (4 e 5 FORI)','03/2005 > 11/2009'],
['7BEFCBED91','OPEL','ASTRA J','P-J (5x105) 1.3 e 1.4 Dis, 1.4 e 1.6 Benz','12/2009 > 2018'],
['BBEFCBED91','OPEL','ASTRA K','B-K','10/2015 > 10/2021'],
['CBEFCBED91','OPEL','ASTRA K SPORTSTOURER','B-K','03/2016 > 10/2021'],
['EAEFCBED91','OPEL','ASTRA L','F','11/2021 >'],
['A8A9981FA','OPEL','ASTRA TWIN TOP','A-H/C','2006 > 10/2009'],
['E736A91FA','OPEL','COMBO (M1)','E','2018 >'],
['E1AEB91FA','OPEL','COMBO (N1)','E','2018 >'],
['A8402A1FA','OPEL','CORSA','S-D','10/2006 > 10/2014'],
['92EFCBED91','OPEL','CORSA 1.7 CDTI','C','10/2000 > 09/2006'],
['AC115A1FA','OPEL','CORSA 1.7cc','S-D','10/2006 > 10/2014'],
['A2B83A1FA','OPEL','CORSA OPC','S-D','10/2006 > 2014'],
['A6896A1FA','OPEL','CORSA-E 1,6 TURBO OPC','S-D','06/2015 > 08/2019'],
['AA5A9A1FA','OPEL','CORSA-E 4H','S-D','11/2014 > 08/2019'],
['AE68DD1FA','OPEL','CORSA-E 5H','S-D','2015 > 08/2019'],
['AEBB9E1FA','OPEL','CORSA-F','U','11/2019 >'],
['A61A3E1FA','OPEL','GRANDLAND - GRANDLAND X','Z','08/2017 >'],
['A66DFE1FA','OPEL','GRANDLAND HYBRID - GRANDLAND X HYBRID','Z','2020 >'],
['A0454B1FA','OPEL','KARL','D-A','2015 >'],
['4BAD5B1FA','OPEL','MERIVA','S-D MONOCAB','06/2010 > 2013'],
['A4167B1FA','OPEL','MERIVA Facelift','S-D MONOCAB','2014 >'],
['A8E6AB1FA','OPEL','MOKKA','J-A','2012 > 2015'],
['AEC15C1FA','OPEL','SIGNUM','Z-C/S','2003 >'],
['43A28C1FA','OPEL','TIGRA','X-C','2004 >'],
['A0EBCC1FA','OPEL','VECTRA-C','Z-C - Z-C/SW','2002 > 2008'],
['A2F54D1FA','OPEL','ZAFIRA','T 98','1999 > 2004'],
['43F54D1FA','OPEL','ZAFIRA','A-H','2005 > 2014'],
['A2BE52D2B','PEUGEOT','107','P - PG','2005 > 2014'],
['AC1772D2B','PEUGEOT','108','P','2014 >'],
['A4C8D2D2B','PEUGEOT','207','W','2006 >'],
['AE21F2D2B','PEUGEOT','208','C','2012 > 2018'],
['4F21F2D2B','PEUGEOT','208','U','2019 >'],
['F1EFCBED91','PEUGEOT','208 GT-LINE','U','06/2019 >'],
['A89903D2B','PEUGEOT','208 Gti','C','04/2013 > 2018'],
['430223D2B','PEUGEOT','3008','M','2017 >'],
['A20223D2B','PEUGEOT','3008','0U - HU','05/2009 > 2016'],
['A04B63D2B','PEUGEOT','307','3','08/2003 > 2008'],
['414B63D2B','PEUGEOT','307','3','2001 > 07/2003'],
['AAA383D2B','PEUGEOT','308','L','10/2013 > 2021'],
['4BA383D2B','PEUGEOT','308','4','11/2007 > 2012'],
['A8ECC3D2B','PEUGEOT','4007','V','01/2007 >'],
['A255E3D2B','PEUGEOT','4008','B','2012 >'],
['A62614D2B','PEUGEOT','407','6','2004 > 12/2010'],
['419E24D2B','PEUGEOT','5008','M','2017 >'],
['A09E24D2B','PEUGEOT','5008','0','10/2009 > 2016'],
['AAF644D2B','PEUGEOT','508','8','03/2011 > 2017'],
['4BF644D2B','PEUGEOT','508','F','2018 >'],
['AEC774D2B','PEUGEOT','607','9','08/2003 > 2009'],
['4FC774D2B','PEUGEOT','607','9','1999 > 07/2003'],
['AA6670D2B','PEUGEOT','BIPPER (M1)','A','2008 >'],
['4B6670D2B','PEUGEOT','BIPPER (M1)','225L','2008 >'],
['45DE80D2B','PEUGEOT','BIPPER (N1)','225L','2008 >'],
['A4DE80D2B','PEUGEOT','BIPPER (N1)','A','2008 >'],
['A8F281D2B','PEUGEOT','PARTNER (M1)','7','06/2008 > 2018'],
['A26B91D2B','PEUGEOT','PARTNER (N1)','7','06/2008 > 2018'],
['AA4A05D2B','PEUGEOT','RIFTER (M1)','E','2018 >'],
['A4B225D2B','PEUGEOT','RIFTER - PARTNER (N1)','E','2018 >'],
['A4507F1B11','POLESTAR','POLESTAR 2 NOT BREMBO BRAKES','V','2020 >'],
['A2B48A86B','PORSCHE','CAYENNE (92A-92AN) DIESEL','92A-92AN','06/2010 > 2017'],
['A685BA86B','PORSCHE','CAYENNE (92A-92AN) S','92A-92AN','06/2010 > 2017'],
['AE271B86B','PORSCHE','CAYENNE (92A-92AN) TURBO - CAYENNE GTS','92A-92AN','06/2010 > 2017'],
['AC606B86B','PORSCHE','CAYENNE (92A-92AN) V6','92A-92AN','06/2010 > 2017'],
['A0FDCA86B','PORSCHE','CAYENNE (92AH-92AHN) S HYBRID','92AH-92AHN','06/2010 > 2017'],
['A2084B86B','PORSCHE','CAYENNE (9PA) V6','9PA','2003 > 05/2010'],
['AAA9AB86B','PORSCHE','CAYENNE (9PA) V8','9PA','2003 > 05/2010'],
['AE7ADB86B','PORSCHE','CAYENNE (9PA) V8 TURBO','9PA','2003 > 05/2010'],
['AC44FF86B','PORSCHE','MACAN (95B) NEW STAGGERED/DIFFERENZIATO','95B','2019 >'],
['A6BC0096B','PORSCHE','MACAN (95B) S NEW STAGGERED/DIFFERENZIATO','95B','2019 >'],
['A23F9096B','PORSCHE','MACAN (95B) TURBO NEW STAGGERED/DIFFERENZIATO','95B','2019 >'],
['A0945C86B','PORSCHE','MACAN (95B-95BN) S DIESEL STAGGERED/DIFFERENZIATO','95B - 95BN','2014 > 2018'],
['AAFC6C86B','PORSCHE','MACAN (95B-95BN) S STAGGERED/DIFFERENZIATO','95B - 95BN','2014 > 2018'],
['A4658C86B','PORSCHE','MACAN (95B-95BN) TURBO STAGGERED/DIFFERENZIATO','95B - 95BN','2014 > 2018'],
['A4B49DFDB','RENAULT','CAPTUR','R','2013 > 2019'],
['AE1DADFDB','RENAULT','CLIO','B','1998 > 2004'],
['A885CDFDB','RENAULT','CLIO (III SERIE)','R','2005 > 2012'],
['A2FDDDFDB','RENAULT','CLIO (IV SERIE)','R','2013 > 2018'],
['A4EBE20EB','RENAULT','CLIO (V SERIE)','RJA','04/2019 >'],
['AC56FDFDB','RENAULT','CLIO RS','R','2013 > 2018'],
['EB9F3EFDB','RENAULT','ESPACE','RFC','2015 >'],
['A4085EFDB','RENAULT','FLUENCE','Z','10/2009 >'],
['A8D88EFDB','RENAULT','KADJAR','RFE','2015 >'],
['A225330EB','RENAULT','KANGOO III (M1)','RFK','2021 >'],
['AEB33FFDB','RENAULT','KOLEOS','Y','06/2008 > 2016'],
['4FB33FFDB','RENAULT','KOLEOS','RZG','2017 >'],
['ACFC7FFDB','RENAULT','LAGUNA III','T','11/2007 > 2015'],
['A0DDAFFDB','RENAULT','LATITUDE','T','2008 >'],
['A2E7200EB','RENAULT','MEGANE I','DA','1995 > 2002'],
['AC40400EB','RENAULT','MEGANE II','DA','2003 > 08/2008'],
['A6B8500EB','RENAULT','MEGANE III','Z','09/2008 > 2015'],
['A021700EB','RENAULT','MEGANE III RS','Z','2011 > 2015'],
['AEF0420EB','RENAULT','MEGANE IV','RFB','2016 >'],
['A869520EB','RENAULT','MEGANE IV GT','RFB','2016 >'],
['A4F1A00EB','RENAULT','MEGANE SCENIC','JA','1999 > 2002'],
['A8C2D00EB','RENAULT','MODUS','P','2004 >'],
['A23BE00EB','RENAULT','SCENIC II','JM','2003 > 05/2009'],
['AC93010EB','RENAULT','SCENIC III','JZ','06/2009 > 2015'],
['A498220EB','RENAULT','TALISMAN','RFD','2016 >'],
['4FAD710EB','RENAULT','TWINGO II','C06','1997 > 05/2007'],
['AEAD710EB','RENAULT','TWINGO II','N','06/2007 > 2013'],
['A816910EB','RENAULT','TWINGO III - TWINGO III GT','AH','2014 >'],
['A0C7F10EB','RENAULT','WIND COUPE','N','08/2010 >'],
['AA20120EB','RENAULT','ZOE','AG','2013 > 2019'],
['4B20120EB','RENAULT','ZOE','AG','2020 >'],
['AA85D075C','SAAB','9 3','YS3F','1998 >'],
['AE560175C','SAAB','9-3 CABRIO','YS3F','2002 >'],
['AA228A29C','SEAT','ALHAMBRA','7N','05/2010 >'],
['A49A9A29C','SEAT','ALTEA - ALTEA XL','5P - 5PN','2004 >'],
['A227AB29C','SEAT','ARONA','KJ','2018 >'],
['A86BCA29C','SEAT','AROSA','6H','1998 > 2004'],
['A8BE8B29C','SEAT','ATECA','5FP','2016 >'],
['AC3CFA29C','SEAT','EXEO - EXEO ST','3R','04/2009 >'],
['88A41B29C','SEAT','IBIZA','6J - 6JN','2001 > 06/2008'],
['47A41B29C','SEAT','IBIZA','6J - 6JN','07/2008 > 2016'],
['C9A41B29C','SEAT','IBIZA','6L','2002 > 2008'],
['6AA41B29C','SEAT','IBIZA','KJ','2017 >'],
['A01D2B29C','SEAT','LEON','1M','1999 > 2004'],
['411D2B29C','SEAT','LEON','1P','2005 > 2012'],
['E11D2B29C','SEAT','LEON','5F','2013 > 2019'],
['821D2B29C','SEAT','LEON','KL','2020 >'],
['AC8FBB29C','SEAT','LEON CUPRA (221Kw)','5F','2013 > 2019'],
['AA754B29C','SEAT','LEON X-PERIENCE','5F','2013 > 2019'],
['A4ED5B29C','SEAT','Mii','AA-AAN','01/2012 >'],
['A6F7DB29C','SEAT','TARRACO','KN','2019 >'],
['80567B29C','SEAT','TOLEDO','NH','2013 >'],
['AA6BDD90D','SKODA','CITIGO','AA-AAN','01/2012 >'],
['AA026F90D','SKODA','ENYAQ','NY','2020 >'],
['E5D3FD90D','SKODA','FABIA','PJ','2021 >'],
['45D3FD90D','SKODA','FABIA','5J','2007 > 2020'],
['A0A94F90D','SKODA','KAMIQ','NW','10/2019 >'],
['ACC81F90D','SKODA','KAROQ','NU','2018 >'],
['A2600F90D','SKODA','KODIAQ','NS','2017 >'],
['A8A42E90D','SKODA','OCTAVIA','5E','04/2013 > 2019'],
['8AA42E90D','SKODA','OCTAVIA','NX','2020 >'],
['E9A42E90D','SKODA','OCTAVIA','1Z','2004 > 2012'],
['49A42E90D','SKODA','OCTAVIA','1U','1996 > 2003'],
['1DDFCBED91','SKODA','OCTAVIA RS','5E','08/2013 > 08/2017'],
['A21D3E90D','SKODA','OCTAVIA SCOUT','5E','04/2013 > 2019'],
['E31D3E90D','SKODA','OCTAVIA SCOUT','NX','2020 >'],
['431D3E90D','SKODA','OCTAVIA SCOUT','1Z','2004 > 2012'],
['A8F7EE90D','SKODA','OCTAVIA WAGON','5E','04/2013 > 2019'],
['49F7EE90D','SKODA','OCTAVIA WAGON','NX','2020 >'],
['AC755E90D','SKODA','PRAKTIK','5J','2008 >'],
['A6ED6E90D','SKODA','RAPID','NH','2013 >'],
['A0568E90D','SKODA','ROOMSTER','5J','09/2006 >'],
['AABE9E90D','SKODA','ROOMSTER SCOUT','5J','09/2006 >'],
['4527BE90D','SKODA','SUPERB','3T','07/2008 > 2014'],
['A427BE90D','SKODA','SUPERB','3T','06/2015 >'],
['8627BE90D','SKODA','SUPERB','3U','2002 > 06/2008'],
['AE8FCE90D','SKODA','YETI','5L','10/2009 >'],
['A470A754D','SMART','FORFOUR II - FORFOUR II BRABUS','451(453)','2014 >'],
['AC120854D','SMART','FORTWO II SERIE STAGGERED/DIFFERENZIATO','451','01/2007 > 2013'],
['4F756118D','SSANGYONG','KORANDO','CW','2020 > 2021'],
['AA41EACBD','SUBARU','BRZ','ZC - GC/GF','2012 > 2022'],
['4F121BCBD','SUBARU','FORESTER','SG','2002 > 06/2008'],
['AE121BCBD','SUBARU','FORESTER','SH','07/2008 > 2012'],
['EF121BCBD','SUBARU','FORESTER','SJ','2014 > 2019'],
['E98A2BCBD','SUBARU','IMPREZA','G4','2013 > 2017'],
['8A8A2BCBD','SUBARU','IMPREZA','G5','2018 >'],
['498A2BCBD','SUBARU','IMPREZA','G3 - G3S','10/2007 > 2012'],
['A6C37BCBD','SUBARU','JUSTY','M3','11/2007 >'],
['A03C8BCBD','SUBARU','LEGACY','BM/BR','11/2009 > 2014'],
['AA94ABCBD','SUBARU','LEVORG','V1','10/2015 >'],
['E50DBBCBD','SUBARU','OUTBACK - LEGACY','B6','2015 > 2020'],
['860DBBCBD','SUBARU','OUTBACK - LEGACY','B7','2021 >'],
['A40DBBCBD','SUBARU','OUTBACK - LEGACY','BM/BR','10/2009 > 2014'],
['A4FC268FD','SUZUKI','BALENO','EW','2016 >'],
['FCEFCBED91','SUZUKI','GRAND VITARA','JT','04/2005 >'],
['E927D48FD','SUZUKI','IGNIS','MF','2017 >'],
['ACF7058FD','SUZUKI','KIZASHI','FR','03/2010 >'],
['4FDFCBED91','SUZUKI','LIANA','ER','2001 > 2007'],
['A660258FD','SUZUKI','S-CROSS (SX4)','JY','09/2013 > 2016'],
['4760258FD','SUZUKI','S-CROSS (SX4)','JY','2017 >'],
['AA31558FD','SUZUKI','SPLASH','EX','2008 >'],
['A8CD568FD','SUZUKI','SWACE','ZE1HE','2020 >'],
['A4A9658FD','SUZUKI','SWIFT 4H','EZ','06/2006 > 09/2010'],
['E5A9658FD','SUZUKI','SWIFT 4H','MZ','2005 > 2009'],
['86A9658FD','SUZUKI','SWIFT 4H','AZ','2017 >'],
['45A9658FD','SUZUKI','SWIFT 4H','NZ','10/2010 > 2016'],
['A2E2B58FD','SUZUKI','SWIFT 4WD 4X4 4H','FZ','10/2010 > 2016'],
['AC4BC58FD','SUZUKI','SWIFT 4X4 4H','EZ','06/2006 > 09/2010'],
['A87A958FD','SUZUKI','SWIFT SPORT 2WD 5H','NZ','11/2011 > 2016'],
['497A958FD','SUZUKI','SWIFT SPORT 2WD 5H','AZ','2018 >'],
['AE02858FD','SUZUKI','SWIFT SPORT 5H','MZ','12/2006 > 10/2011'],
['A6B3E58FD','SUZUKI','SX4','EY','2006 > 2013'],
['47B3E58FD','SUZUKI','SX4','GY','2006 > 2013'],
['412CF58FD','SUZUKI','VITARA','LY','03/2015 >'],
['AAC391BAE','TOYOTA','AURIS','E15..','02/2007 > 2012'],
['4BC391BAE','TOYOTA','AURIS','E15..','2013 >'],
['A43CA1BAE','TOYOTA','AURIS HYBRID I','HE15..','08/2010 > 2012'],
['AE94C1BAE','TOYOTA','AURIS HYBRID II','HE15..','2013 >'],
['A275F1BAE','TOYOTA','AVENSIS','T22 - T25','2003 > 2008'],
['E375F1BAE','TOYOTA','AVENSIS','T27','2009 >'],
['61FFCBED91','TOYOTA','AVENSIS 2.2D','T25','04/2003 > 01/2008'],
['ACDD02BAE','TOYOTA','AVENSIS VERSO','M2','2003 >'],
['474622BAE','TOYOTA','AYGO','AB1','2014 >'],
['A64622BAE','TOYOTA','AYGO','AB1','2005 > 2013'],
['ACB1A6BAE','TOYOTA','C-HR','AX1T','2017 >'],
['41BE32BAE','TOYOTA','CAMRY','XV7','2019 >'],
['A0BE32BAE','TOYOTA','CAMRY','V3 - V2','2002 > 2017'],
['E950A2BAE','TOYOTA','COROLLA','ZE1HE','2019 >'],
['4950A2BAE','TOYOTA','COROLLA','E15EJ(A) - E15ES(A)','2014 > 2018'],
['0AEFCBED91','TOYOTA','COROLLA','E15EJ, E15ES','2007 > 2014'],
['A850A2BAE','TOYOTA','COROLLA','E','1995 > 2007'],
['A2C8B2BAE','TOYOTA','COROLLA VERSO','R1','2004 >'],
['AA01A4BAE','TOYOTA','PREVIA','R3','1995 > 2000'],
['A479B4BAE','TOYOTA','PRIUS +','XW4(A) - XW3(A)','06/2012 >'],
['A84AE4BAE','TOYOTA','PRIUS III','XW3(A)','06/2009 > 2015'],
['A41046BAE','TOYOTA','PRIUS IV','XW5','2016 >'],
['A0E597BAE','TOYOTA','PROACE CITY (N1)','E','2020 >'],
['A67D77BAE','TOYOTA','PROACE CITY VERSO (M1)','E','2020 >'],
['E78335BAE','TOYOTA','RAV 4','XA3','2013 > 2015'],
['888335BAE','TOYOTA','RAV 4','XA4','2016 > 2018'],
['298335BAE','TOYOTA','RAV 4','XA5','2019 >'],
['478335BAE','TOYOTA','RAV 4','XA3','2006 > 2012'],
['A68335BAE','TOYOTA','RAV 4','XA1-A2','1994 > 2005'],
['9DDFCBED91','TOYOTA','RAV 4 HYBRID','TGRE,XA5P(EU,M)','01/2019 >'],
['A2AC47BAE','TOYOTA','SUPRA','JBSC-JTSC','2019 >'],
['A89DA5BAE','TOYOTA','VERSO','AR2-AR2N','04/2009 >'],
['4D6ED5BAE','TOYOTA','YARIS','XP9','1999 > 08/2011'],
['AC6ED5BAE','TOYOTA','YARIS','XP13..','09/2011 > 2019'],
['ED6ED5BAE','TOYOTA','YARIS','XPA1F (KA - KL)','07/2020 >'],
['A4B6C7BAE','TOYOTA','YARIS CROSS HYBRID','XPB1F','2021 >'],
['AA4EA7BAE','TOYOTA','YARIS GR','XPA1G','2021 >'],
['A6D6F5BAE','TOYOTA','YARIS HYBRID','XP13..','09/2011 > 2019'],
['47D6F5BAE','TOYOTA','YARIS HYBRID','XPA1F (KB)','07/2020 >'],
['A04F06BAE','TOYOTA','YARIS VERSO','P2','1999 > 08/2011'],
['AA604B6EE','VOLKSWAGEN','AMAROK','2H','10/2010 >'],
['A44DB37EE','VOLKSWAGEN','ARTEON','3H','07/2017 >'],
['A4D85B6EE','VOLKSWAGEN','BEETLE - MAGGIOLINO','16','2012 >'],
['4312AB6EE','VOLKSWAGEN','CADDY (M1)','SK','2021 >'],
['4B28647EE','VOLKSWAGEN','CADDY (N1)','SKN','2021 >'],
['AA28647EE','VOLKSWAGEN','CADDY (N1)','2K-2KN','2016 > 2020'],
['AC7ABB6EE','VOLKSWAGEN','CADDY LIFE (M1)','2K','2004 > 2015'],
['4D7ABB6EE','VOLKSWAGEN','CADDY LIFE (M1)','2K-2KN','2016 > 2020'],
['AE843C6EE','VOLKSWAGEN','CROSS TOURAN','1T','2003 >'],
['A8FC4C6EE','VOLKSWAGEN','e-UP','AA','2013 >'],
['A2656C6EE','VOLKSWAGEN','EOS','1F','2006 >'],
['A6369C6EE','VOLKSWAGEN','FOX','5Z','2005 >'],
['A2B82D6EE','VOLKSWAGEN','GOLF IV','1J','1997 > 2002'],
['A6895D6EE','VOLKSWAGEN','GOLF V','1K','01/2003 > 2007'],
['AC640E6EE','VOLKSWAGEN','GOLF V VARIANT','1KM','2003 > 2007'],
['A0453E6EE','VOLKSWAGEN','GOLF VI','1K','11/2008 > 2011'],
['AE7E7E6EE','VOLKSWAGEN','GOLF VI PLUS','1KP','2009 > 2011'],
['EDDFCBED91','VOLKSWAGEN','GOLF VI R','1K','02/2010 > 10/2012'],
['ACB7CE6EE','VOLKSWAGEN','GOLF VII','AU-1K','09/2012 > 2019'],
['A620EE6EE','VOLKSWAGEN','GOLF VII ALLTRACK','AUV-1KM','2015 > 2019'],
['FDDFCBED91','VOLKSWAGEN','GOLF VII GTI','AU','05/2013 >'],
['A098FE6EE','VOLKSWAGEN','GOLF VII SPORTSVAN','AUV-1KM','2014 > 2019'],
['A4692F6EE','VOLKSWAGEN','GOLF VII VARIANT','AUV-1KM','2013 > 2019'],
['A490847EE','VOLKSWAGEN','GOLF VIII','CD','2020 >'],
['A6AAF47EE','VOLKSWAGEN','GOLF VIII GTI','CD','2020 >'],
['AFEFCBED91','VOLKSWAGEN','GOLF VIII GTI Clubsport','CD','10/2020 >'],
['A4E3457EE','VOLKSWAGEN','GOLF VIII R','CD','2021 >'],
['AC32E47EE','VOLKSWAGEN','GOLF VIII VARIANT','CDV','2020 >'],
['AEF8947EE','VOLKSWAGEN','ID3','E1','08/2020 >'],
['A861B47EE','VOLKSWAGEN','ID4 - ID4 GTX','E2','2020 >'],
['EFC14F6EE','VOLKSWAGEN','JETTA','16','2011 >'],
['70EFCBED91','VOLKSWAGEN','JETTA','1M,1KM','2004 > 2010'],
['AA44DF6EE','VOLKSWAGEN','LUPO','6','1998 > 2005'],
['A4BCEF6EE','VOLKSWAGEN','NEW BEETLE','9C','1998 > 2011'],
['AE15007EE','VOLKSWAGEN','NEW BEETLE CABRIO','1Y','2003 >'],
['A88D107EE','VOLKSWAGEN','PASSAT','3C (B8)','11/2014 >'],
['E98D107EE','VOLKSWAGEN','PASSAT','3C','2004 > 10/2014'],
['8A8D107EE','VOLKSWAGEN','PASSAT','3B','2004 > 2009'],
['498D107EE','VOLKSWAGEN','PASSAT','3B','1996 > 2003'],
['A2F5307EE','VOLKSWAGEN','PASSAT ALLTRACK','3C','06/2012 > 10/2014'],
['43F5307EE','VOLKSWAGEN','PASSAT ALLTRACK','3C (B8)','11/2014 >'],
['A6C6607EE','VOLKSWAGEN','PASSAT CC','3CC','06/2008 > 2016'],
['0EDFCBED91','VOLKSWAGEN','PASSAT GTE 2020','3C','03/2020 >'],
['AAD4A37EE','VOLKSWAGEN','PASSAT VARIANT','3C (B8)','11/2014 >'],
['A400B07EE','VOLKSWAGEN','PHAETON','3D','2002 >'],
['C178C07EE','VOLKSWAGEN','POLO','9N','2001 > 2004'],
['A8D0E07EE','VOLKSWAGEN','POLO (V SERIE)','6R','06/2009 > 2016'],
['A81EE37EE','VOLKSWAGEN','POLO (VI SERIE)','AW','10/2017 >'],
['A249F07EE','VOLKSWAGEN','POLO CROSS (IV SERIE)','9N','2005 > 05/2009'],
['ACA1117EE','VOLKSWAGEN','POLO CROSS(V SERIE)','6R','06/2009 > 2016'],
['A61A217EE','VOLKSWAGEN','POLO FUN (IV SERIE)','9N','2005 > 05/2009'],
['7FEFCBED91','VOLKSWAGEN','POLO GTI','6R','05/2010 > 06/2018'],
['ACEE147EE','VOLKSWAGEN','POLO GTI (VI SERIE)','AW','2018 >'],
['A082417EE','VOLKSWAGEN','POLO R WRC','6R','2013 >'],
['AAEA517EE','VOLKSWAGEN','SCIROCCO','13','09/2008 >'],
['AEBB817EE','VOLKSWAGEN','SHARAN','7N','05/2010 >'],
['A0CF447EE','VOLKSWAGEN','T-CROSS','C1','2019 >'],
['AEA5D37EE','VOLKSWAGEN','T-ROC','A1','2018 >'],
['4DEFCBED91','VOLKSWAGEN','T4','7*','06/1990 > 04/2003'],
['5DEFCBED91','VOLKSWAGEN','T5','7*','04/2003 > 06/2015'],
['6DEFCBED91','VOLKSWAGEN','T6','7*','06/2015 > 12/2019'],
['7DEFCBED91','VOLKSWAGEN','T6.1','7*','12/2019 >'],
['43EFCBED91','VOLKSWAGEN','TAIGO','CS','11/2021 >'],
['A824A17EE','VOLKSWAGEN','TIGUAN','5N','2007 > 2015'],
['4924A17EE','VOLKSWAGEN','TIGUAN','5N','2016 >'],
['A286047EE','VOLKSWAGEN','TIGUAN ALLSPACE','5N','2017 >'],
['ACF4D17EE','VOLKSWAGEN','TOUAREG','7P','03/2010 > 2017'],
['4DF4D17EE','VOLKSWAGEN','TOUAREG','7L','2003 > 02/2010'],
['EDF4D17EE','VOLKSWAGEN','TOUAREG','CR','2018 >'],
['4977627EE','VOLKSWAGEN','TOURAN','1T','2003 > 08/2015'],
['A877627EE','VOLKSWAGEN','TOURAN','1T','09/2015 >'],
['AC9B537EE','VOLKSWAGEN','UP','AA-AAN','01/2012 >'],
['A604737EE','VOLKSWAGEN','UP CROSS','AA-AAN','01/2012 >'],
['AA0DE422F','VOLVO','C30','M','2006 >'],
['A4750522F','VOLVO','C70','M','05/2006 >'],
['45750522F','VOLVO','C70','N','1997 > 04/2006'],
['49463522F','VOLVO','S40','M','2004 >'],
['84BE4522F','VOLVO','S60','Z','2019 >'],
['E3BE4522F','VOLVO','S60','R - H','2000 > 08/2010'],
['43BE4522F','VOLVO','S60','F','09/2010 > 2017'],
['A8ECB622F','VOLVO','S60 Cross Country','F','2016 > 2018'],
['AC176522F','VOLVO','S80','A','05/2006 >'],
['4D176522F','VOLVO','S80','T - K - KV','1998 > 04/2006'],
['478F7522F','VOLVO','S90','P','09/2016 >'],
['A0F79522F','VOLVO','V40','M','06/2012 >'],
['AA50B522F','VOLVO','V40 Cross Country','M','2013 >'],
['A4C8C522F','VOLVO','V50','M','2004 >'],
['4F21E522F','VOLVO','V60','Z','2018 >'],
['AE21E522F','VOLVO','V60','F','09/2010 > 2017'],
['A899F522F','VOLVO','V60 Cross Country','F','2015 > 2017'],
['4999F522F','VOLVO','V60 Cross Country','Z','11/2018 >'],
['A2021622F','VOLVO','V60 Hybrid','G','2013 > 2017'],
['AC6A2622F','VOLVO','V70','B','10/2007 >'],
['4D6A2622F','VOLVO','V70','S - J - JV','2000 > 09/2007'],
['47D24622F','VOLVO','V90','P','09/2016 >'],
['A255D622F','VOLVO','V90 Cross Country','P','2017 >'],
['A6260722F','VOLVO','XC40','X','2018 >'],
['A46F4722F','VOLVO','XC40 RECHARGE P8','X','2021 >'],
['A04B5622F','VOLVO','XC60','D','11/2008 > 2017'],
['414B5622F','VOLVO','XC60','U','2018 >'],
['AAA37622F','VOLVO','XC70','B','10/2007 >'],
['4BA37622F','VOLVO','XC70','S - J - JV','2000 > 09/2007'],
['A41C8622F','VOLVO','XC90','L','06/2015 >']
];